import { VisionButton } from "@/components/VisionUI"
import { Heading, Text, useDisclosure } from "@chakra-ui/react"
import { useTranslation } from "react-i18next"

import { useSemanticColors } from "@/hooks/useSemanticColors"
import DeleteConfirmation from "./DeleteConfirmation"

const DeleteAccount = () => {
  const { t } = useTranslation(["settings", "common"])
  const sc = useSemanticColors()
  const confirmationModal = useDisclosure()

  return (
    <>
      <Heading size="md" color={sc.heading} mb={4}>
        {t("settings:deleteAccount.title")}
      </Heading>
      <Text color={sc.textMuted}>
        {t("settings:deleteAccount.description")}
      </Text>
      <VisionButton
        variant="dark"
        mt={4}
        onClick={confirmationModal.onOpen}
        style={{ borderColor: "rgba(255,100,100,0.4)" }}
      >
        {t("common:actions.delete")}
      </VisionButton>
      <DeleteConfirmation
        open={confirmationModal.open}
        onClose={confirmationModal.onClose}
      />
    </>
  )
}
export default DeleteAccount
